import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable, map } from 'rxjs';
import { IApiResponse } from '../../../../shared/models/api-response';
import { ISimPublication } from '../models/sr/sim-publication';
@Injectable({
  providedIn: 'root'
})

export class DocumentService {

  baseUrl: string = `${environment.servicesUrl.document}api/Document`;

  constructor(
    private http: HttpClient,
  ) { }

  getAgedDocumentsForManualSRSBallot(committeeCode: string | null = null, search: string | null = null): Observable<IApiResponse<ISimPublication[]>> {
    const committeeQuery = committeeCode ? `committee=${committeeCode}` : `committee=`;
    const searchQuery = search ? `search=${search}` : `search=`;
    return this.http
      .get<IApiResponse<ISimPublication[]>>(`${this.baseUrl}/get-aged-documents-for-manual-srs-ballot?${committeeQuery}&${searchQuery}`);
  }

}
